<app-spinner *ngIf="isLoadingFlightData" placement="full-page"></app-spinner>
<div *ngIf="!isLoadingFlightData" class="admin-page-wrapper">
<!-- admin-flight-data.component.html -->
<h2>Admin Test Flight Options</h2>

<div class="controls">
  <button class="btn btn-primary" (click)="openSeedPopup()">Seed Test Data</button>
  <button class="btn btn-secondary" (click)="refreshTestDataTiming()">Refresh Test Dates</button>
  <p class="feedback">{{ seedFeedback }}</p>
  <p class="feedback error" *ngIf="loadError">{{ loadError }}</p>
</div>

<table class="flight-table">
  <thead>
    <tr>
      <th>Display Name</th>
      <th>Departure</th>
      <th>Arrival Exact</th>
      <th>Arrival Exact S,C,T</th>
      <th>Arrival Gen Type</th>
      <th>Arrival Gen State</th>
      <th>Arrival Gen Country</th>
      <th>Date Exact</th>
      <th>Date Rng Start</th>
      <th>Date Rng End</th>
      <th>Time Exact</th>
      <th>Time Rng Start</th>
      <th>Time Rng End</th>
      <th>Seats Offer</th>
      <th>Seats Needed</th>
      <th>Aircraft</th>
      <th>Est Hours</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let option of flightOptions">
      <td>{{option.creatorDisplayName || '- -'}}</td>
      <td>{{option.departureLocationName }}</td>
      <td>{{option.arrivalLocationName || '- -' }}</td>
      <td>{{option.arrivalPreciseState || '' }}, {{ option.arrivalPreciseCountry || '' }}, {{ option.arrivalPreciseType || '' }}</td>
      <td>{{option.arrivalGeneralType || '- -' }}</td>
      <td>{{option.arrivalGeneralState || '- -' }}</td>
      <td>{{option.arrivalGeneralCountry || '- -' }}</td>
      <td>{{option.departureDateExact || '- -' }}</td>
      <td>{{option.departureDateRangeStart || '- -'}}</td>
      <td>{{option.departureDateRangeEnd || '- -'}}</td>
      <td>{{option.departureTimeExact || '- -' }}</td>
      <td>{{option.departureTimeRangeStart || '- -'}}</td>
      <td>{{option.departureTimeRangeEnd || '- -'}}</td>
      <td>{{option.seatsOffered || '- -'}}</td>
      <td>{{option.seatsNeeded || '- -'}}</td>
      <td>{{option.aircraft || '- -'}}</td>
      <td>{{option.estimatedFlightHours || '- -'}}</td>
      <td>
        <button class="btn btn-edit" (click)="editFlightOption(option)">
            <app-svg-loader height="20px" url="assets/svg/edit-cube.svg"></app-svg-loader>
        </button>
        <button class="btn btn-delete" (click)="deleteFlightOption(option.id)">
            <app-svg-loader height="20px" url="assets/svg/trash-cube.svg"></app-svg-loader>
        </button>
      </td>
    </tr>
  </tbody>
</table>

<!-- Edit Popup -->
<div class="popup-overlay" *ngIf="showEditPopup" (click)="closeEditPopup()">
  <div class="popup" (click)="$event.stopPropagation()" #editPopup>
    <h3>Edit Flight Option</h3>
    <form *ngIf="selectedFlightOption" (ngSubmit)="saveFlightOption()">
      <div class="form-group">
        <label for="departureLocationName">Departure Location</label>
        <input
          id="departureLocationName"
          [(ngModel)]="selectedFlightOption.departureLocationName"
          name="departureLocationName"
          type="text"
          required
        >
      </div>
      <div class="form-group">
        <label for="arrivalLocationName">Arrival Location</label>
        <input
          id="arrivalLocationName"
          [(ngModel)]="selectedFlightOption.arrivalLocationName"
          name="arrivalLocationName"
          type="text"
        >
      </div>
      <div class="form-group">
        <label for="departureDateExact">Departure Date</label>
        <input
          id="departureDateExact"
          [(ngModel)]="selectedFlightOption.departureDateExact"
          name="departureDateExact"
          type="date"
        >
      </div>
      <div class="form-group">
        <label for="departureDateExact">Seats Needed</label>
        <input
          id="seatsNeeded"
          [(ngModel)]="selectedFlightOption.seatsNeeded"
          name="seatsNeeded"
          type="string"
        >
      </div>
      <div class="form-actions">
        <button class="btn btn-cancel" type="button" (click)="closeEditPopup()">Cancel</button>
        <button class="btn btn-save" type="submit">Save</button>
      </div>
    </form>
  </div>
</div>

<!-- Seed Popup -->
<div class="popup-overlay" *ngIf="showSeedPopup" (click)="closeSeedPopup()">
  <div class="popup" (click)="$event.stopPropagation()" #seedPopup>
    <section *ngIf="!isGeneratingSeedData">
        <h3>Seed Test Flight Data</h3>
        <form #myForm="ngForm" (ngSubmit)="saveSeedData(myForm)">
          <div class="form-group">
            <label for="departureCities">Departure Cities (one per line)</label>
            <textarea
              id="departureCities"
              [(ngModel)]="departureCitiesInput"
              name="departureCities"
              rows="4"
            ></textarea>
          </div>
          <div class="form-group">
            <label for="arrivalCities">Arrival Cities (one per line)</label>
            <textarea
              id="arrivalCities"
              [(ngModel)]="arrivalCitiesInput"
              name="arrivalCities"
              rows="4"
            ></textarea>
          </div>
          <div class="form-group">
            <label for="dateRangeStart">Date Range Start</label>
            <input
              id="dateRangeStart"
              [(ngModel)]="seedParams.dateRangeStart"
              name="dateRangeStart"
              type="date"
            >
          </div>
          <div class="form-group">
            <label for="dateRangeEnd">Date Range End</label>
            <input
              id="dateRangeEnd"
              [(ngModel)]="seedParams.dateRangeEnd"
              name="dateRangeEnd"
              type="date"
            >
          </div>
          <div class="form-group">
            <label for="numResults">Number of Results</label>
            <input
              id="numResults"
              [(ngModel)]="seedParams.numResults"
              name="numResults"
              type="number"
              min="1"
            >
          </div>
          <div class="form-actions">
            <button class="btn btn-cancel" type="button" (click)="closeSeedPopup()">Cancel</button>
            <button class="btn btn-save" type="submit">Seed</button>
          </div>
        </form>
    </section>
    <div class="seed-loader" *ngIf="isGeneratingSeedData">
      <!-- VAR -->
        <app-spinner size="24px" color="#57dcd8"></app-spinner>
        <p>Generating Test Data Seed</p>
    </div>
  </div>
</div>

</div>
